'use strict';

/**
 * Tests for matchMedia API support and if media query is met
 *
 * @param   {String}   [mediaQuery] - Media query string
 * @param   {Boolean}  [condition]  - Condition statement
 * @returns {Boolean}
 */
var addMQListener, matchMQ;

matchMQ = function(mediaQuery, condition) {
  var isMatchMedia;
  if (mediaQuery == null) {
    mediaQuery = Groupon.LS.mediaQueries.mMax;
  }
  if (condition != null) {
    if (!condition) {
      return false;
    }
  }
  isMatchMedia = typeof matchMedia === 'function';
  return (isMatchMedia && matchMedia(mediaQuery).matches) || !isMatchMedia;
};

addMQListener = function(mediaQuery, listener, condition) {
  var isMatchMedia;
  if (mediaQuery == null) {
    mediaQuery = Groupon.LS.mediaQueries.mMax;
  }
  if (condition != null) {
    if (!condition) {
      return false;
    }
  }
  isMatchMedia = typeof matchMedia === 'function';
  return (matchMedia(mediaQuery).addListener(listener)) || !isMatchMedia;
};

module.exports = {
  matchMQ: matchMQ,
  addMQListener: addMQListener
};

